<template>
  <div v-bind:class="{
          'row-walk': mode === 'WALK',
          'row-bicycle': mode === 'BICYCLE',
        }">
    <div v-if="step.farligeKryds"></div>
    <div
      v-for="(farligKryds, index) in step.farligeKryds"
      :key="index"
    >
      <FarligKryds :farligKryds="farligKryds" />
    </div>
    <div class="row-flex">
      <DirectionIcon
        :direction="step.relativeDirection"
        :color="mode === 'WALK' ? primaryColors[700] : pinkColors[500]"
      />
      <div class="detail-text">
        <span v-if="index === 0">Start {{ absoluteDirectionToDanish(step.absoluteDirection) }} ad {{ step.streetName }}</span>
        <span v-else>
          <span v-if="step.exit">Tag den {{ toOrdinal(step.exit) }} frakørselen i rundkørslen
            ind på {{ step.streetName }}</span>
          <span v-else>{{ relativeDirection(step.relativeDirection) }}
            {{
            [
            'RIGHT',
            'LEFT',
            'HARD_RIGHT',
            'HARD_LEFT',
            'SLIGHTLY_LEFT',
            'SLIGHTLY_RIGHT',
            ].indexOf(step.relativeDirection) > -1
            ? 'ind på'
            : 'ad'
            }}
            {{ step.streetName }}</span>
        </span>
        <small>{{getDistanceString(step.distance)}}</small>
      </div>
      <span class="tool-tip">Zoom til i kort</span>
    </div>
  </div>
</template>

<script>
import FarligKryds from '@/components/Itinerary/FarligKryds.vue';
import DirectionIcon from '@/components/Icons/Directions/DirectionIcon.vue';
import {
  absoluteDirectionToDanish,
  getDistanceString,
  relativeDirectionToDanish,
  capitalizeFirstLetter,
  toDanishOrdinal,
} from '@/util';

import { primary, pink } from '@/util/style';
export default {
  name: 'step',
  components: { FarligKryds, DirectionIcon },
  props: { step: Object, mode: String, index: Number },
  data: function() {
    return {
      getDistanceString,
      primaryColors: primary,
      pinkColors: pink,
      absoluteDirectionToDanish,
      capitalizeFirstLetter,
    };
  },
  methods: {
    relativeDirection(r) {
      return capitalizeFirstLetter(relativeDirectionToDanish(r));
    },
    toOrdinal(num) {
      return toDanishOrdinal(num);
    },
  },
};
</script>
